import { useEffect, useState } from "react";
import { Card, CardBody, CardHeader } from "../../../components/card/card.jsx";
import { dataTel3GetDetailPart, detailTrainingTel3Data } from "../../../config/apiSPA.js";
import { Link, useNavigate, useParams } from "react-router-dom";
import { BsFiletypePdf } from "react-icons/bs";
import Tel3PdfGenerator from "../../../services/pdfGenerator/tel3PdfGenerator.js";
import ModalLoadingPage from "../../../components/modal/loadingPage.jsx";
import ModalResultPart from "../../tel3/modal/modalResultPart.jsx";
import SpinnerSection from "../../../components/spinner/spinnerSecion.jsx";

function TrainingReportTel3({ startDate = null }) {
  const { id } = useParams();
  const [found, setFound] = useState(false);
  const [dataPart, setDataPart] = useState(null);
  const [mainData, setMainData] = useState(null);
  const [modalGenPdf, setModalGenPdf] = useState({ show: false, text: "Preparing your PDF..." });
  const [modalResultPart, setModalResultPart] = useState({ show: false, id: null });
  const [loadingPage, setLoadingPage] = useState(true);
  const [eligible, setEligible] = useState(true);
  const navigate = useNavigate();
  const onGeneratePdf = async (e) => {
    try {
      setModalGenPdf((a) => ({ ...a, show: true }));
      const res = await dataTel3GetDetailPart(e);
      await Tel3PdfGenerator(res.data);
    } catch (error) {
      console.log(error);
    } finally {
      setModalGenPdf((a) => ({ ...a, show: false }));
    }
  };
  const handleClickDetailPart = (e) => {
    setModalResultPart({ show: true, id: e });
  };
  const countEligible = () => {
    const trainingDate = new Date(startDate); // pastikan startDate ada
    const now = new Date();
    // tambah 3 bulan dari tanggal training
    const tel3AvailableDate = new Date(trainingDate);
    tel3AvailableDate.setMonth(tel3AvailableDate.getMonth() + 3);
    setEligible(now >= tel3AvailableDate);
  };
  const loadData = async () => {
    try {
      const res = await detailTrainingTel3Data(id);
      setDataPart(res.data.participant);
      setMainData(res.data);
      setLoadingPage(false);
      setFound(true);
    } catch (error) {
      setFound(false);
      countEligible();
      setLoadingPage(false);
    }
  };
  useEffect(() => {
    loadData();
  }, [startDate, id]);
  if (loadingPage) return <SpinnerSection title="Training Evaluasi Level 3 (Behavior)" />;
  return (
    <>
      <Card className="mb-4">
        <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">Training Evaluasi Level 3 (Behavior)</CardHeader>
        <CardBody className="card-body pb-2">
          {/* =================== */}
          {/* Tel3 Not Found Section  */}
          {/* =================== */}
          {!found && (
            <div>
              <div className="mb-2">
                <div className="d-block d-lg-flex align-items-center">
                  <button onClick={() => navigate(`/training-evaluation-3/new`)} className="btn btn-outline-theme me-2 mb-1" disabled={!eligible}>
                    <i className="fa fa-fw fa-plus"></i>
                    <span>Create TEL 3</span>
                  </button>
                </div>
              </div>
              {eligible ? <p>Training evaluasi level 3 not found in this training event</p> : <p>Belum waktunya membuat TEL 3 karena training belum berjalan 3 bulan.</p>}
            </div>
          )}
          {/* =================== */}
          {/* Tel3 Found Section  */}
          {/* =================== */}
          {found && (
            <div>
              {dataPart?.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-hover text-nowrap">
                    <thead>
                      <tr>
                        <th className="border-top-0 pt-0 pb-2">No.</th>
                        <th className="border-top-0 pt-0 pb-2">Name</th>
                        <th className="border-top-0 pt-0 pb-2">Evaluator</th>
                        <th className="border-top-0 pt-0 pb-2">Final Score (Max:4)</th>
                        <th className="border-top-0 pt-0 pb-2">Percentage</th>
                        <th className="border-top-0 pt-0 pb-2"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataPart.map((val, index) => (
                        <tr key={val.id}>
                          <td className="align-middle">{`${index + 1}.`}</td>
                          <td className="align-middle">{val.signaturePath ? <Link onClick={() => handleClickDetailPart(val.id)}>{val.partData.nama}</Link> : val.partData.nama} </td>
                          <td className="align-middle">
                            {val.evaluator ? (
                              <>{val.evaluator.nama}</>
                            ) : (
                              <>
                                <i className="text-danger">Evaluator Not Found</i>
                              </>
                            )}
                          </td>
                          <td className="align-middle">{val.signaturePath ? val.finalScore : "Not Scored"}</td>
                          <td className="align-middle">{val.signaturePath ? val.percentage + " %" : "-"}</td>
                          <td className="align-middle">
                            {val.signaturePath ? (
                              <a href="#/" onClick={() => onGeneratePdf(val.id)} title="generate pdf">
                                <BsFiletypePdf />
                              </a>
                            ) : (
                              <BsFiletypePdf />
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p>No Data</p>
              )}
              <div className="mb-3 mt-3">
                <Link to={`/training-evaluation-3/detail/${mainData.id}`} className="toggle">
                  More Detail
                </Link>
              </div>
            </div>
          )}
        </CardBody>
      </Card>
      <ModalLoadingPage hide={() => setModalGenPdf((a) => ({ ...a, show: false }))} show={modalGenPdf.show} text={modalGenPdf.text} />
      <ModalResultPart show={modalResultPart.show} handleClose={() => setModalResultPart((a) => ({ ...a, show: false }))} id={modalResultPart.id} />
    </>
  );
}
export default TrainingReportTel3;
